"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIErrors = void 0;
class APIErrors {
}
exports.APIErrors = APIErrors;
APIErrors.list = {
    isError: true,
    key: "list",
    template: "Failed to read entries of directory \"%s\"."
};
APIErrors.addEntry = {
    isError: true,
    key: "addEntry",
    template: "Failed to add entry \"%s\"."
};
APIErrors.login = {
    isError: true,
    key: "login",
    template: "Failed to log in with user name \"%s\"."
};
APIErrors.logout = {
    isError: true,
    key: "logout",
    template: "Failed to log out.",
};
APIErrors.invalidServerReply = {
    isError: true,
    key: "invalidServerReply",
    template: "The server reply is invalid."
};
APIErrors.httpError = {
    isError: true,
    key: "httpError",
    template: "The server replied with status %s when requesting %s."
};
APIErrors.httpErrorShort = {
    isError: true,
    key: "httpErrorShort",
    template: "The server replied with status %s."
};
APIErrors.serverRefusedPlainPassword = {
    isError: true,
    key: "serverRefusedPlainPassword",
    template: "Refused to send plain password over non-secured connection."
};
APIErrors.serverError = {
    isError: true,
    key: "serverError",
    template: "The server replied: %s"
};
APIErrors.getMetaData = {
    isError: true,
    key: "getMetaData",
    template: "Failed to get meta data for file \"%s\"."
};
APIErrors.copyDir = {
    isError: true,
    key: "copyDir",
    template: "Failed to copy directory \"%s\" to \"%s\"."
};
APIErrors.copyFile = {
    isError: true,
    key: "copyFile",
    template: "Failed to copy file \"%s\" to \"%s\"."
};
APIErrors.invalidTargetPath = {
    isError: true,
    key: "invalidTargetPath",
    template: "The target path is invalid."
};
APIErrors.queueStoppedWithErrors = {
    isError: true,
    key: "queueStoppedWithErrors",
    template: "The queue stopped due to errors."
};
APIErrors.logoutNotLoggedIn = {
    isError: true,
    key: "logoutNotLoggedIn",
    template: "Logout failed. There is no active session."
};
APIErrors.createDir = {
    isError: true,
    key: "createDir",
    template: "Failed to create directory \"%s\"."
};
APIErrors.invalidDirName = {
    isError: true,
    key: "invalidDirName",
    template: "The directory name contains the following invalid characters: \"%s\"."
};
APIErrors.rename = {
    isError: true,
    key: "rename",
    template: "Failed to rename \"%s\" to \"%s\"."
};
APIErrors.invalidServiceName = {
    isError: true,
    key: "invalidServiceName",
    template: "\"%s\" is not a valid service name."
};
APIErrors.invalidNewName = {
    isError: true,
    key: "invalidNewName",
    template: "The new name contains the following invalid characters: \"%s\"."
};
APIErrors.noValidFile = {
    isError: true,
    key: "noValidFile",
    template: "The path \"%s\" is missing a valid file."
};
APIErrors.invalidPath = {
    isError: true,
    key: "invalidPath",
    template: "The path \"%s\" is invalid."
};
APIErrors.reImportFile = {
    isError: true,
    key: "reImportFile",
    template: "Failed to re-import file \"%s\"."
};
APIErrors.reImportDir = {
    isError: true,
    key: "reImportDir",
    template: "Failed to re-import directory \"%s\"."
};
APIErrors.reImportNothing = {
    isError: true,
    key: "reImportNothing",
    template: "Option \"image\" or \"meta data\" (or both) must be selected for re-import."
};
APIErrors.queueRunning = {
    isError: true,
    key: "queueRunning",
    template: "Cannot start queue, already running"
};
APIErrors.downloadFile = {
    isError: true,
    key: "downloadFile",
    template: "Failed to download \"%s\"."
};
APIErrors.upload = {
    buttons: ["skip", "skipAll", "cancel"],
    isError: true,
    key: "upload",
    noContinueText: true,
    template: "Failed to upload \"%s\".",
};
APIErrors.anyError = {
    isError: true,
    key: "anyError",
    template: "\"%s\""
};
APIErrors.userAborted = {
    isError: true,
    key: "userAborted",
    template: "Aborted by user"
};
APIErrors.batchNonLocalFiles = {
    isError: true,
    key: "batchNonLocalFiles",
    template: "Failed to run \"%s\", because the queue contains non local files."
};
APIErrors.batchLocalFiles = {
    isError: true,
    key: "batchLocalFiles",
    template: "Failed to run \"%s\", because the queue contains local files."
};
APIErrors.isDirectory = {
    isError: true,
    key: "isDirectory",
    template: "\"%s\" is a directory."
};
APIErrors.changePassWord = {
    isError: true,
    key: "changePassWord",
    template: "Failed to set a new password."
};
APIErrors.getUserList = {
    isError: true,
    key: "getUserList",
    template: "Failed to load user list."
};
APIErrors.changeUser = {
    isError: true,
    key: "changeUser",
    template: "Failed to change user to \"%s\"."
};
APIErrors.deleteFile = {
    buttons: ["skip", "skipAll", "cancel"],
    isError: true,
    key: "deleteFile",
    noContinueText: true,
    template: "Failed to delete file \"%s\"."
};
APIErrors.deleteDir = {
    buttons: ["skip", "skipAll", "cancel"],
    isError: true,
    key: "deleteDir",
    noContinueText: true,
    template: "Failed to delete directory \"%s\"."
};
APIErrors.changeMetaData = {
    buttons: ["skip", "skipAll", "cancel"],
    isError: true,
    key: "changeMetaData",
    noContinueText: true,
    template: "Failed to change the meta data of \"%s\"."
};
